import React from 'react';
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  useTheme,
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/styles';
import clsx from 'clsx';
import StarIcon from '@material-ui/icons/Star';
import StepsMLStyled from './StepsMLStyles';

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 36,
  },
  active: {
    '& $line': {
      backgroundColor: '#666464',
    },
  },
  completed: {
    '& $line': {
      backgroundColor: '#1565C0',
    },
  },
  line: {
    height: 2,
    border: 0,
    backgroundColor: '#D3D3D3',
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#D3D3D3',
    zIndex: 1,
    color: '#fff',
    width: 76,
    height: 76,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    background: '#666464',
  },
  completed: {
    background: '#1565C0',
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <StarIcon className="step-icon-style" />,
    2: <StarIcon className="step-icon-style" />,
    3: <StarIcon className="step-icon-style" />,
    4: <StarIcon className="step-icon-style" />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

function getSteps() {
  return ['基本设置', '奖项设置', '样式设置', '通知设置'];
}
export default ({ activeStep }) => {
  const steps = getSteps();
  const theme = useTheme();
  return (
    <StepsMLStyled theme={theme}>
      <Box>
        <Stepper
          className="step-wrap"
          alternativeLabel
          activeStep={activeStep}
          connector={<ColorlibConnector />}
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    </StepsMLStyled>
  );
};
